import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default class FlexiblesAnchors{
    
    constructor(element) {
        this._wrapper = element;
        this._header = document.querySelector('.js-header');
        this._blocks = this._wrapper.querySelectorAll('.js-flexibles-anchors-blocks');
        this._btns = this._wrapper.querySelectorAll('.js-flexibles-anchors-btn');
        
        this.init();
    }
    
    init(){
        [...this._blocks].forEach((el,n) => {
            let isLastIteration = n === this._blocks.length -1;
            ScrollTrigger.create({
                trigger:el,
                start:isLastIteration ? 'top bottom-=10': "top top+="+this.getHeaderHeight(),
                endTrigger:el,
                end:"bottom top",
                markers:false,
                onEnter:() => {
                    app.nodesRemoveClass(this._btns, 'is-active');
                    this._btns[n].classList.add('is-active');
                },
                onEnterBack:() => {
                    app.nodesRemoveClass(this._btns, 'is-active');
                    this._btns[n].classList.add('is-active');
                },
                onLeaveBack:() => {
                    if(isLastIteration){
                        app.nodesRemoveClass(this._btns, 'is-active');
                        this._btns[n - 1].classList.add('is-active');
                    }
                }
            });
        });
    }
    
    getHeaderHeight(){
        return this._header.getBoundingClientRect().height + 15;
    }
}